import React, { useState, useEffect } from "react";
import {
  TextField,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@mui/material";
import SriyanshCardHeader from "../../components/CardHeader";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import EncryptService from "../../service/EncryptionService";
import { useNavigate } from "react-router-dom";

function UpdateUser() {
  const [role, setRole] = useState("");
  const [roles, setRoles] = useState([]);
  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);
  const [fname, setfName] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [consignee, setConsignee] = useState("");
  const [consignees, setConsignees] = useState([]);
  const [updateBtn, setUpdateBtn] = useState(true);

  const navigate = useNavigate();
  const tokenServiceDetails = TokenService.getUserDetails();
  const logineuname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  const sortItems = (items) =>
    [...items].sort((a, b) => a.Shop.localeCompare(b.Shop));

  const handleTransferToSelected = (item) => {
    const updatedList1 = list1.filter(
      (i) => i.ConsigneeCode !== item.ConsigneeCode
    );
    const updatedList2 = [...list2, item];
    setList1(sortItems(updatedList1));
    setList2(sortItems(updatedList2));
  };

  const handleTransferToAvailable = (item) => {
    const updatedList2 = list2.filter(
      (i) => i.ConsigneeCode !== item.ConsigneeCode
    );
    const updatedList1 = [...list1, item];
    setList1(sortItems(updatedList1));
    setList2(sortItems(updatedList2));
  };

  const fetchConsignees = async () => {
    try {
      const response = await apiClient.post("/ConsigneeList");
      setConsignees(response.data);
      setList1(response.data);
    } catch (error) {
      console.error("Error Fetching Consignee:", error);
    }
  };
  const toProperCase = (str) =>
    str
      .replace(/^\s+/, "") // Remove leading spaces
      .replace(/\s+/g, " ")
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ")
      ;
  const fetchRoles = async () => {
    try {
      const response = await apiClient.post("/roleList");
      setRoles(response.data);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const fetchUserData = () => {
    apiClient
      .post("/getUserData", { uname: logineuname, userName1: username })
      .then((response) => {
        const consigneeCodes = response.data[0]?.consignee;

        if (!consigneeCodes) {
          //console.error("ConsigneeCode is undefined or empty");
          return;
        }

        const selectedCodes = consigneeCodes.split(",");

        apiClient
          .post("/ConsigneeList")
          .then((response) => {
            const list1 = response.data;

            // Filter items based on selected codes
            const filteredData = list1.filter((item) =>
              selectedCodes.includes(item?.ConsigneeCode?.toString())
            );
            setList2(filteredData);

            // Remove items in selectedCodes from list1
            const updatedList1 = list1.filter(
              (item) => !selectedCodes.includes(item?.ConsigneeCode?.toString())
            );
            setList1(updatedList1);
          })
          .catch((error) =>
            console.error("Error fetching ConsigneeList:", error)
          );
      })
      .catch((error) => {
        if (error.code === "ERR_BAD_REQUEST") {
          alert("Invalid User Name");
          setUpdateBtn(true);
        } else {
          console.error("Error fetching user data:", error);
        }
      });
  };

  const getUserData = async () => {
    try {
      const response = await apiClient.post("/getUserData", {
        uname: logineuname,
        userName1: username,
      });
      const data = response.data[0];
      setEmail(data.emailid);
      setMobileNumber(data.mobilenumber);
      setfName(data.FullName);
      setRole(data.userrights);
      setConsignee(data.consignee ? data.consignee : "");
      setUpdateBtn(false);
    } catch (error) {
      setfName("");
      setEmail("");
      setMobileNumber("");
      setUpdateBtn(true);
    }
  };

  useEffect(() => {
    fetchConsignees();
    fetchRoles();
  }, []);

  useEffect(() => {
    if (consignees.length > 0) {
      setConsignee(
        consignees[0].ConsigneeCode ? consignees[0].ConsigneeCode : ""
      );
    }
    if (roles.length > 0) {
      setRole(roles[2]?.id);
    }
  }, [consignees, roles, username]);

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setMobileNumber(value);
    }
  };

  const UpdatOldUser = async (e) => {
    e.preventDefault();
    let formErrors = {};
    if (!fname) formErrors.name = "Name is required";
    if (!email) formErrors.email = "Email is required";
    if (!username) formErrors.username = "Username is required";
    if (!mobileNumber) formErrors.mobileNumber = "Mobile number is required";
    if (mobileNumber && mobileNumber.length !== 10)
      formErrors.mobileNumber = "Mobile number must be 10 digits";
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailPattern.test(email)) {
      formErrors.email = "Email is invalid";
    }
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const itemCodes =
        list2.length > 0
          ? list2.map((item) => item.ConsigneeCode).join(",")
          : "91145"; // Only generate itemCodes if list2 is not empty


          const vconsignee1 =
          ((role === 3 || role === 4 || role === 6) && itemCodes) ? itemCodes : (consignee || "91145");

     // const vconsignee1 =
     //   role === 4 && itemCodes ? itemCodes : consignee || "91145";
      // console.log(username);
      // console.log(role);
      // console.log(fname);
      // console.log(email);
      // console.log(mobileNumber);
      // console.log(logineuname);
      // console.log(ip);
      // console.log(consignee);
      // console.log(vconsignee1);
      // console.log(role);
      // console.log(itemCodes);

      try {
        await apiClient.post("/updateUser", {
          uname: username,
          rights: role,
          fname: fname,
          email: email,
          mobile: mobileNumber,
          cretedby: logineuname,
          vip: ip,
          vconsignee: vconsignee1,
        });
        setfName("");
        setEmail("");
        setMobileNumber("");
        setUsername("");
        if (roles.length > 0) {
          setRole(roles[2]?.role);
        }
      } catch (error) {
        console.error("Error updating user:", error);
      }
    }
  };

  const handleClose = () => {
    navigate("../", { replace: true });
  };

  return (
    <div >
      {/* <SriyanshCardHeader Title="Update User" /> */}
      <Card className="Formcard ">
      <div className="input-groupHeading">
      Update User

            </div>
        <CardContent>
          <div className="row">
          <div className="container">
            <div className="input-group">
              <TextField
                label="User ID"
                variant="outlined"
                size="small"
                value={username}
                onChange={(e) => setUsername(e.target.value.toLowerCase())}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    getUserData();
                    fetchUserData();
                  }
                }}
                fullWidth
                error={!!errors.username}
                helperText={errors.username}
                inputProps={{ maxLength: 10 }}
              />
            </div>

            <div className="input-group">
              <TextField
                label="Email"
                size="small"
                variant="outlined"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value.toLowerCase())}
                fullWidth
                error={!!errors.email}
                helperText={errors.email}
                inputProps={{ maxLength: 50 }}
              />
            </div>
          </div>

          <div className="container">
            <div className="input-group">
              <TextField
                label="Full Name"
                variant="outlined"
                size="small"
                value={fname}
                onChange={(e) => setfName(toProperCase(e.target.value))}
                fullWidth
                error={!!errors.fname}
                helperText={errors.fname}
                inputProps={{ maxLength: 30 }}
              />
            </div>

            <div className="input-group">
              <TextField
                label="Mobile Number"
                variant="outlined"
                type="tel"
                size="small"
                value={mobileNumber}
                onChange={handleMobileNumberChange}
                fullWidth
                error={!!errors.mobileNumber}
                helperText={errors.mobileNumber}
                inputProps={{ maxLength: 10, pattern: "[0-9]*" }}
              />
            </div>
          </div>

          <div className="container">
            <div className="input-group">
              <DropdownfromDatabaseList
              size="small"
                Options={roles} //ARRAY COMPONENT
                option={role} // VALUE VARIABLE
                setOptionValue={setRole} //SET VALUE VARIBALE
                DisplayItem1="role"
                DisplayItem2="id"
              />
            </div>

            {(role === 3 || role === 4 || role=== 6) && (
              <div className="container">
                {/* List 1: Available Consignees */}
                <div className="input-group">
                  <Box
                    sx={{
                      width: "100%",
                      border: "1px solid #ccc",
                      borderRadius: 2,
                      overflow: "auto",
                      maxHeight: 300, // Optional scrollable height
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{
                        backgroundColor: "#f0f0f0",
                        padding: "8px",
                        borderBottom: "1px solid #ccc",
                        textAlign: "center",
                      }}
                    >
                      Available Consignees
                    </Typography>
                    <List>
                      {list1.map((item) => (
                        <ListItem
                          key={item.ConsigneeCode}
                          button
                          onClick={() => handleTransferToSelected(item)}
                        >
                          <ListItemText
                            primary={item.Shop}
                            secondary={item.ConsigneeCode}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                </div>

                {/* List 2: Selected Consignees */}
                <div className="input-group">
                  <Box
                    sx={{
                      width: "100%",
                      border: "1px solid #ccc",
                      borderRadius: 2,
                      overflow: "auto",
                      maxHeight: 300, // Optional scrollable height
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{
                        backgroundColor: "#f0f0f0",
                        padding: "8px",
                        borderBottom: "1px solid #ccc",
                        textAlign: "center",
                      }}
                    >
                      Selected Consignees
                    </Typography>
                    <List>
                      {list2.map((item) => (
                        <ListItem
                          key={item.ConsigneeCode}
                          button
                          onClick={() => handleTransferToAvailable(item)}
                        >
                          <ListItemText
                            primary={item.Shop}
                            secondary={item.ConsigneeCode}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                </div>
              </div>
            )}

            {role === 2 && (
              <div className="input-group">
                <DropdownfromDatabaseList
                  Options={consignees}
                  option={consignee}
                  setOptionValue={setConsignee}
                  DisplayItem1="Shop"
                  DisplayItem2="ConsigneeCode"
                  showKeyInLabel={true}
                />
              </div>
            )}
          </div>

          <>
            <div
              className="container flex"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={UpdatOldUser}
                title="Click for user update"
                disabled={updateBtn}
              >
                Update Login
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default UpdateUser;
